module.exports = __webpack_public_path__ + "img/slide03.5028d61c.png";